<div class="snackbars-wrapper">
  <ng-container *ngFor="let toast of toasts$ | async; let i = index">
    <div
      [id]="'snackbar-' + toast.id"
      class="snackbar {{ toast.type }} fadein mat-elevation-z12"
      [class.show]="toast.message != ''"
      [attr.data-cy]="'toast-type-' + toast.type">
      <button
        mat-button
        mat-icon-button
        class="snackbar__close"
        data-cy="toast-close"
        (click)="dismiss(toast)">
        <mat-icon svgIcon="close"></mat-icon>
      </button>
      <ng-container *ngIf="toast.type == 'SUCCESS'">
        <mat-icon
          class="snackbar__icon"
          svgIcon="check-circle-outline"></mat-icon>
      </ng-container>
      <ng-container *ngIf="toast.type == 'ERROR'">
        <mat-icon
          class="snackbar__icon"
          svgIcon="alert-circle"></mat-icon>
      </ng-container>
      <ng-container *ngIf="toast.type == 'INFO'">
        <mat-icon
          class="snackbar__icon"
          svgIcon="information-outline"></mat-icon>
      </ng-container>
      <div class="snackbar__body">
        {{
          (toast.message | i18n) || toast.message || "Keine Übersetzung: "
            | i18n: toast.messageOptions || {}
        }}
      </div>
      <div
        class="snackbar__timeout"
        [ngStyle]="setTimeoutAnimation(toast)"></div>
    </div>
  </ng-container>
</div>
